import React from "react";

import Button from "@mui/material/Button";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

import ConfirmDialogProps from "./ConfirmDialogProps";

function ConfirmDialog(props: ConfirmDialogProps) {
  const cancelButton = (
    <Button
      color={props.cancelButtonColor === undefined ? "error" : props.cancelButtonColor}
      variant="contained"
      startIcon={props.cancelButtonIcon === undefined ? <CloseIcon /> : props.cancelButtonIcon}
      onClick={() => {
        props.handleCancel();
        props.setOpen(false);
      }}
    >
      {props.cancelButtonMessage || "Cancel"}
    </Button>
  );

  const confirmButton = (
    <Button
      color={props.confirmButtonColor === undefined ? "primary" : props.confirmButtonColor}
      startIcon={props.confirmButtonIcon === undefined ? <CheckIcon /> : props.confirmButtonIcon}
      onClick={() => {
        props.handleConfirm();
        props.setOpen(false);
      }}
    >
      {props.confirmButtonMessage || "Confirm"}
    </Button>
  );

  return (
    <Dialog open={props.open} onClose={props.handleCancel}>
      <DialogTitle>{props.confirmationTitle || "Are you sure?"}</DialogTitle>
      <DialogContent>
        <DialogContentText>{props.confirmationMessage || null}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between" }}>
        {props.confirmOnLeft ? confirmButton : null}
        {cancelButton}
        {props.confirmOnLeft ? null : confirmButton}
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDialog;
